<script>
  import axios from "axios"
  import { onDestroy, onMount } from "svelte"
  import { tweened } from "svelte/motion"
  import { cubicOut } from "svelte/easing"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import Tab from "../../Shared/tab.svelte"
  import { push, querystring } from "svelte-spa-router"
  import Footer from "../../../../../Shared/footer.svelte"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import bulkJson from "../../Stores/jsonBulkData"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import FilePage from "./Components/filePage.svelte"
  import Counter from "../../Shared/counter2.svelte"
  import notify from "../../../../../Script/notify"
  import Loader from "../../../../../Shared/Slots/loader.svelte"
  import AuthInput from "../../../../../Shared/authInput.svelte"
  import DocumentStatusContent from "./Components/documentStatusContent.svelte"
  import { fetchBulkStatus, fetchBulkTemplate } from "../../Script/bulkUpload"

  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let jsonDataSign = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let signatureInProcess = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let publishProcess = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let onFirstQueue = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let onSecondQueue = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let onThirdQueue = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let onFourthQueue = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let onFifthQueue = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let publishInProcess = []
  /**
   * @type {"Document Status"|"Files"} active tab while generating files
   */
  let activeItem = "Publishing Status"
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  let activeDoc = "start"
  /**
   * @type {Number} number of files the signature to be generated
   */
  let signatureGenerated = 0
  /**
   * @type {Number} number of files to be published
   */
  let publishedDocuments = 0
  /**
   * @type {Number} number of files to be published
   */
  let failedDocuments = 0
  /**
   * @type {Number} the total number of documents to be uploaded
   */
  let totalDoc = 0
  /**
   * @type {Number} the count which reflects the increment limit of the progress bar
   */
  let incrementLimit
  /**
   * @type {String} activeColor of the tabs
   */
  let activeColor
  /**
   * @type {Number} initial width of the progress bar
   */
  let width = 0
  /**
   * @type {Boolean} whether to show toggle or not
   */
  let showLoading = false
  /**
   * @type {String} the text to be shown while loading
   */
  let loadingText = "Fetching Bulk Upload data&nbsp;&nbsp;"
  /**
   * @type {Boolean} whether to show confirmation modal or not
   */
  let showConfirmationModal = false
  /**
   * @type {String} the confirmation code for publishing documents
   */
  let code
  /**
   * @type {boolean} whether to show the email button or not
   */
  let showEmailButton = false
  /**
   * @type {Boolean} name of the start button
   */
  let startBtnName = "Publish"
  /**
   * @type {Object} stores the query value in the current url
   */
  let query
  /**
   * Creates a tweened value representing the width of a progress indicator.
   *
   * @param {number} initialValue - The initial value of the tweened width.
   * @param {Object} options - Options for configuring the tween animation.
   * @param {number} options.duration - The duration of the tween animation in milliseconds.
   * @param {function} options.easing - The easing function used for the animation.
   * @returns {Object} - A tweened value object that represents the width of the progress indicator.
   */
  const widthofProgress = tweened(0, {
    duration: 400,
    easing: cubicOut,
  })
  /**
   * @type {String} validation code for signature
   */
  let signProxyPass
  let closeNotification = {
    close() {},
  }

  onMount(async () => {
    try {
      // Set showLoading to true to indicate loading state
      showLoading = true
      // Parse the query string into a JavaScript object
      query = queryStringToJSON($querystring)
      // Redirect to the bulk publishing page if the "id" parameter is missing in the query
      if (!query.id) {
        push("/publish/bulk")
        return
      }
      // Fetch data about the bulk publishing status using the "id" from the query
      let apiData = await fetchBulkStatus(query.id)

      // Redirect based on the status of the bulk publishing
      if (apiData.status == "active" || apiData.status == "revoked") {
        push(`/documents/bulk/view-report?id=${query.id}`)
        return
      }

      if (apiData.status == "published") {
        if (apiData.sendEmail) {
          push(`/publish/bulk/send-email?id=${query.id}`)
          return
        }
      }

      if (apiData.status == "started") {
        if (!apiData.generateFile) push(`/publish/bulk/upload-file?id=${query.id}`)
        else push(`/publish/bulk/generate-file?id=${query.id}`)
        return
      }

      // Determine whether to show an email button based on the sendEmail property from apiData
      showEmailButton = apiData.sendEmail

      // Fetch data about the bulk template using the "id" from the query
      let bulkData = await fetchBulkTemplate(query.id)

      // Update the $bulkJson array with documents from the fetched bulk data
      $bulkJson = [...bulkData.documents]

      // Initialize the "isDocumentFailed" property for each document
      for (let i = 0; i < $bulkJson.length; i++) {
        $bulkJson[i].isDocumentFailed = false
      }

      // Set the totalDoc variable to the total number of documents
      totalDoc = $bulkJson.length

      let tobeProcessed = []

      // Filter documents that have not been signed or published
      tobeProcessed = $bulkJson.filter((a) => !a.txidPublished)

      if (!tobeProcessed.length) {
        // All documents have been signed and published
        activeDoc = "completed"
        signatureGenerated = publishedDocuments = $bulkJson.length
        return
      }

      if (tobeProcessed.length != $bulkJson.length) startBtnName = "Resume"

      // Count documents with signatures generated and published
      signatureGenerated = publishedDocuments = $bulkJson.length - tobeProcessed.length

      // Calculate the increment limit for progress
      incrementLimit = 100 / ($bulkJson.length * 2)

      // changing the width of the ongoing file generation process
      changeWidth(signatureGenerated + publishedDocuments)

      for (let i = 0; i < tobeProcessed.length; i++) {
        tobeProcessed[i].countForPublish = 0
      }

      // Store filtered documents in jsonDataSign
      jsonDataSign = [...tobeProcessed]
    } catch (error) {
      const info = "PAGE: Sign and Publish (Bulk Upload)\nEVENT: onMount"
      notify.danger(error, info)
      push("/publish/bulk")
    } finally {
      // Set showLoading to false to indicate that loading is complete
      showLoading = false
    }
  })

  /**
   * Function to update the width of a progress indicator based on the given times.
   * @param {number} times - The number of times to increment the width.
   */
  const changeWidth = (times = 1) => {
    // Check if the increment limit exists
    if (incrementLimit) {
      // Increase the width by the increment limit
      width = width + incrementLimit * times

      // Set the updated width to a variable called "widthofProgress"
      widthofProgress.set(width)

      // Check if the width has reached or exceeded 99%
      if (Math.round(width) >= 99) {
        // Check if the total documents match the sum of published and failed documents
        if (totalDoc == publishedDocuments + failedDocuments) {
          // If there are failed documents, set the activeDoc to "retry," otherwise set it to "completed"
          if (failedDocuments) activeDoc = "retry"
          else activeDoc = "completed"
        }
      }
    }
  }

  /**
   * Function to initiate a document processing workflow.
   * It checks various conditions to determine whether to continue the processing or not.
   */
  const initiateProcess = () => {
    // Filter documents that have not been signed, not published, or not failed
    let tobeProcessed = $bulkJson.filter((a) => !a.signature || !a.txidPublished || !a.isDocumentFailed)

    // Check if there is data in jsonDataSign, or if there are documents to be processed,
    // and whether the processing queues or arrays have data
    if (jsonDataSign.length || (tobeProcessed.length && failedDocuments != totalDoc && publishedDocuments != totalDoc) || publishInProcess.length || onFirstQueue.length || onSecondQueue.length || onThirdQueue.length || onFourthQueue.length || onFifthQueue.length) assignData2Array()
    else {
      // If none of the processing conditions are met, end the processing
      console.timeEnd("publish")
      clearInterval(timer)
      fetchBulkStatus(query.id)
      return
    }
  }

  /**
   * Function for assigning data to respective array
   */
  const assignData2Array = () => {
    // Get the number of hardware threads available for concurrency
    let hwc = window.navigator.hardwareConcurrency

    let timer1, timer2, timer3, timer4, timer5

    // Check if there are available slots for document signature processing
    if (signatureInProcess.length < hwc) {
      // Extract a portion of data from jsonDataSign to fill available slots
      let sArray = jsonDataSign.splice(0, hwc - signatureInProcess.length)

      // Add the extracted data to the signature processing queue
      signatureInProcess = [...signatureInProcess, ...sArray]

      // Start processing signatures for the extracted data
      for (let i = 0; i < sArray.length; i++) {
        getSignature(sArray[i])
      }
    }

    // Check if there are available slots for document publishing
    if (publishInProcess.length < hwc) {
      // Extract a portion of data from publishProcess to fill available slots
      let pArray = publishProcess.splice(0, hwc - publishInProcess.length)

      // Add the extracted data to the publishing processing queue
      publishInProcess = [...publishInProcess, ...pArray]

      // Start processing document publishing for the extracted data
      for (let i = 0; i < pArray.length; i++) {
        initiatePublish(pArray[i])
      }
    }

    // Set up timers and queues for document publishing
    if (onFirstQueue.length) {
      timer1 = setInterval(() => {
        if (!publishProcess.length && !onFirstQueue.length) {
          clearInterval(timer1)
        }
        publishProcess = [...publishProcess, ...onFirstQueue]
        onFirstQueue = []
      }, 5000)
    } else {
      clearInterval(timer1)
    }

    if (onSecondQueue.length) {
      timer2 = setInterval(() => {
        if (!publishProcess.length && !onSecondQueue.length) {
          clearInterval(timer2)
        }
        publishProcess = [...publishProcess, ...onSecondQueue]
        onSecondQueue = []
      }, 10000)
    } else {
      clearInterval(timer2)
    }

    if (onThirdQueue.length) {
      timer3 = setInterval(() => {
        if (!publishProcess.length && !onThirdQueue.length) {
          clearInterval(timer3)
        }
        publishProcess = [...publishProcess, ...onThirdQueue]
        onThirdQueue = []
      }, 15000)
    } else {
      clearInterval(timer3)
    }

    if (onFourthQueue.length) {
      timer4 = setInterval(() => {
        if (!publishProcess.length && onFourthQueue.length) {
          clearInterval(timer4)
        }
        publishProcess = [...publishProcess, ...onFourthQueue]
        onFourthQueue = []
      }, 20000)
    } else {
      clearInterval(timer4)
    }

    if (onFifthQueue.length) {
      timer5 = setInterval(() => {
        if (!publishProcess.length && onFifthQueue.length) {
          clearInterval(timer5)
        }
        publishProcess = [...publishProcess, ...onFifthQueue]
        onFifthQueue = []
      }, 25000)
    } else {
      clearInterval(timer5)
    }

    // Request animation frame to continue the processing
    // window.requestAnimationFrame(initiateProcess)
  }

  /**
   * Function to generate a signature for a document.
   * @param {import("../../Script/document").bulkDocument} data
   */
  const getSignature = async (data) => {
    try {
      // Generate the document signature using the 'generateSignature' function
      let apiData = await generateSignature(data)

      // Find the document entry to be updated in the '$bulkJson' array
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      // Update the document entry with the generated signature
      tobeUpdated.signature = apiData

      // Increment the count of signature-generated documents
      signatureGenerated++

      // Update the progress width
      changeWidth()

      // Add the document to the publishing process queue
      publishProcess.push(tobeUpdated)

      // Remove the document from the '$bulkJson' array
      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Reconstruct the '$bulkJson' array with the updated document entry
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      // $bulkJson = [...$bulkJson.filter((a) => a.id != data.id), tobeUpdated]
    } catch (error) {
      // Handle errors that occur during signature generation
      // failedDocuments++

      // Find the document entry to be updated in the '$bulkJson' array
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      // Set the 'isDocumentFailed' flag to true and store the error message
      tobeUpdated.isDocumentFailed = true
      tobeUpdated.errorMsg = error

      // Remove the document from the '$bulkJson' array
      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Reconstruct the '$bulkJson' array with the updated document entry
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      failedDocuments = $bulkJson.filter((a) => a.isDocumentFailed).length

      // Update the progress width with a factor of 2
      changeWidth(2)

      // Replace the old entry with the updated one in the '$bulkJson' array
      // $bulkJson = [tobeUpdated, ...$bulkJson.filter((a) => a.id != data.id)]
    } finally {
      // Remove the document from the signature processing queue
      signatureInProcess = signatureInProcess.filter((a) => a.id != data.id)
    }
  }

  /**
   * Function to generate a signature for a document.
   * @param {import("../../Script/document").bulkDocument} jsonData
   * @returns {Promise} A promise that resolves with the generated signature data or rejects with an error.
   */
  const generateSignature = (jsonData) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Check if the client is online; throw a network error if not
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        // Send a POST request to the specified URL to generate the signature
        const { data } = await axios.post(
          `/api/swagger/v2/misc/proxy-sign`,
          {
            signProxyPass: signProxyPass,
            msg: `${jsonData.fileHash}${jsonData.dataHash}`,
          },
          {
            headers: {
              "x-access-token": $ApplicationState.token,
            },
          }
        )

        // const { data } = await axios.get(`https://ecdsa.test.print2block.in/sign/5f5bb3376efc0f44c7090574${jsonData.fileHash}${jsonData.dataHash}`)
        // Check if the response contains an error and is not successful; throw an error code if so
        if (data.error && !data.success) {
          throw data.errorCode
        }
        // Resolve the promise with the generated signature data
        resolve(data.signature)
      } catch (error) {
        // Modify error codes and reject the promise with the error or a modified error

        reject(error)
      }
    })
  }

  /**
   * Initiates the publishing process for a document.
   * @param {import("../../Script/document").bulkDocument} data
   */
  const initiatePublish = async (data) => {
    try {
      // Publish the document and get the API response
      let apiData = await publishDocument(data.id, data.signature)

      // Find the document to be updated in the $bulkJson array
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]
      tobeUpdated.countForPublish++

      // Handle documents in the QUEUED state
      if (apiData.state == "QUEUED") {
        // publishProcess.push(data)
        if (tobeUpdated.countForPublish == 6) {
          throw "document failed"
        }
        tobeUpdated.txidPublished = null

        // Distribute documents to queues based on their countForPublish value
        if (tobeUpdated.countForPublish == 1) onFirstQueue.push(tobeUpdated)
        if (tobeUpdated.countForPublish == 2) onSecondQueue.push(tobeUpdated)
        if (tobeUpdated.countForPublish == 3) onThirdQueue.push(tobeUpdated)
        if (tobeUpdated.countForPublish == 4) onFourthQueue.push(tobeUpdated)
        if (tobeUpdated.countForPublish == 5) onFifthQueue.push(tobeUpdated)
      }

      // Handle documents in the PUBLISHED state
      if (apiData.state == "PUBLISHED") {
        tobeUpdated.url = apiData.url
        tobeUpdated.txidPublished = apiData.txidPublished
        publishedDocuments++
        changeWidth()
      }

      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Replace the old entry with the updated one in the '$bulkJson' array
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      // $bulkJson = [...$bulkJson.filter((a) => a.id != data.id), tobeUpdated]
    } catch (error) {
      // Handle errors during the publishing process

      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      tobeUpdated.isDocumentFailed = true
      tobeUpdated.errorMsg = error

      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Replace the old entry with the updated one in the '$bulkJson' array
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      // failedDocuments++
      failedDocuments = $bulkJson.filter((a) => a.isDocumentFailed).length

      changeWidth()

      // Replace the old entry with the updated one in the '$bulkJson' array
      // $bulkJson = [tobeUpdated, ...$bulkJson.filter((a) => a.id != data.id)]
    } finally {
      // Remove the document from the publishInProcess array
      publishInProcess = publishInProcess.filter((a) => a.id != data.id)
    }
  }

  /**
   * Publish a document with the specified ID and signature.
   * @param {string} id - The ID of the document to be published.
   * @param {string} signature - The signature associated with the document.
   * @returns {Promise} A Promise that resolves with the result of the publishing operation or rejects with an error.
   */
  const publishDocument = (id, signature) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Check if the device is online
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

        // Send a POST request to publish the document using axios
        const { data } = await axios.post(
          `/api/swagger/v2/documents/${id}/publish`,
          {
            signature: signature,
          },
          {
            headers: {
              "x-access-token": $ApplicationState.token,
            },
          }
        )

        // Check if the response contains an error and is not successful
        if (data.error && !data.success) {
          throw data.errorCode
        }

        // Resolve the Promise with the result of the publishing operation
        resolve(data)
      } catch (error) {
        // Modify and reject the error, if applicable

        reject(error)
      }
    })
  }

  let timer

  onDestroy(() => {
    clearInterval(timer)
  })

  $: changeActiveColor(activeDoc)

  /**
   * Function for changing the active color of the tabs
   * @param {String} activeDoc the current state of the document status
   */
  const changeActiveColor = (activeDoc) => (activeColor = activeDoc == "completed" ? "#22C55E" : "#FF6A00")

  /**
   * Confirm the authentication code entered by the user.
   * Extracts the code from the input fields, hides the confirmation modal, and triggers a specific function.
   * @param {Event} e - The event object, representing the form submission.
   */
  const confirmAuthCode = async (e) => {
    try {
      let target = e.detail.target

      // Extract the authentication code from the input fields
      code = target[0].value + target[1].value + target[2].value + target[3].value + target[4].value + target[5].value

      signProxyPass = await validateOTP(code)

      // Hide the confirmation modal
      showConfirmationModal = false

      console.time("publish")

      // Set the activeDoc status to "processing"
      activeDoc = "processing"

      // Call the initiateProcess function
      // initiateProcess()

      timer = setInterval(initiateProcess, 30)
    } catch (error) {
      // console.error(error)
      closeNotification.close()
      code = ""
      const info = "PAGE: Sign and Publish (Bulk Upload)\nEVENT: While initiating publishing process"
      closeNotification = notify.danger(error, info)
    }
  }

  /**
   * Function for validating OTP
   * @param {String} code 6 digit validation code
   */
  const validateOTP = async (code) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Send a POST request to validate the verification using axios
        const { data } = await axios.post(
          `/api/swagger/v2/misc/proxy-sign`,
          {
            otp: code,
          },
          {
            headers: {
              "x-access-token": $ApplicationState.token,
            },
          }
        )

        // Check if the response contains an error and is not successful
        if (data.error && !data.success) {
          throw data.errorCode
        }

        // Resolve the Promise with the result of the publishing operation
        resolve(data.signProxyPass)
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * Navigate to the specified route based on the bulk publishing status.
   * @param {string} routeName - The name of the route to navigate to.
   */
  const navigateNextPage = async (routeName) => {
    try {
      showLoading = true
      // Fetch bulk publishing status using the "id" from the query
      let apiData = await fetchBulkStatus(query.id)

      // Check if the bulk publishing status is "published"
      if (apiData.status == "published" || apiData.status == "active") {
        if (routeName == "view-report") {
          push(`/documents/bulk/${routeName}?id=${query.id}`)
        } else {
          push(`/publish/bulk/${routeName}?id=${query.id}`)
        }
      } else window.location.reload()
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: Sign and Publish (Bulk Upload)\nEVENT: While updating bulk status before navigating to report / send email page"
      closeNotification = notify.danger(error, info)

      // Redirect to the bulk publishing page in case of an error
      push("/publish/bulk")
    } finally {
      showLoading = false
    }
  }
</script>

<svelte:head>
  <title>Sign and Publish</title>
</svelte:head>

{#if showConfirmationModal}
  <div class="fixed inset-0 z-50 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
    <div class="relative m-6 transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0 md:w-[700px]">
      <div class="flex w-full items-center justify-center rounded-md bg-white p-3 pb-0 text-black dark:bg-bodyblack md:px-6 md:pt-6">
        <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Confirmation</h1>
      </div>

      <div class="px-3 py-3">
        <AuthInput
          on:click={() => {
            showConfirmationModal = false
          }}
          cancelBtn={true}
          bind:code
          on:submit={confirmAuthCode}
          title="Please provide a <strong>Authentication Code from the linked Authenticator App</strong> to confirm the publication of the document."
        />
      </div>
    </div>
  </div>
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="flex px-6 pb-12 pt-9">
    <div class="relative mx-auto flex w-full max-w-[920px] flex-col rounded-md bg-white dark:bg-mdGray">
      <Tab {activeColor} {activeDoc} bind:activeItem />

      {#if showLoading}
        <div class="flex h-full items-center justify-center text-base text-gray-400">
          <Loader>
            <span class="flex">
              {@html loadingText}
            </span>
          </Loader>
        </div>
      {:else}
        <div class="flex h-full w-full select-none flex-col items-center justify-center p-6 mobile:p-12">
          <!-- <div class=" hidden w-full justify-center gap-6 md:flex">
              <Counter titleText="TOTAL<br>DOCUMENTS" count={totalDoc} innerColor="inset 0px 20px 40px 0px rgba(255, 118, 142, 0.3)" gradient="#ff43c0 0%, #ffa95c 100%" />
              <Counter titleText="SIGNATURES<br>GENERATED" count={signatureGenerated} innerColor="inset 0px 20px 60px 0px rgba(141,142,255,0.3)" gradient="#0db8ff 0%, #f332ff 100%" />
              <Counter titleText="DOCUMENTS<br>PUBLISHED" count={publishedDocuments} innerColor="inset 0px 20px 40px 0px rgba(58,212,173,0.3)" gradient="#39a3ff 0%, #3cff53 100%" />
              <Counter titleText="DOCUMENTS<br>FAILED" count={failedDocuments} innerColor="inset 0px 20px 40px 0px rgba(255,81,47,0.3)" gradient="#FF512F 0%, #DD2476 100%" />
            </div>
            <div class=" flex w-full flex-col justify-center gap-6 md:hidden">
              <Counter titleText="TOTAL<br>DOCUMENTS" count={totalDoc} color={"#ff6a00"} gradient={"#f8a500, #ff6a00"} icon={"fa-solid fa-file-lines"} />
              <Counter titleText="SIGNATURES<br>GENERATED" count={signatureGenerated} color={"#00B2FF"} gradient={"#A3E3FF, #00B2FF"} icon={"fa-solid fa-gear fa-spin"} />
              <Counter titleText="DOCUMENTS<br>PUBLISHED" count={publishedDocuments} color={"#00D515"} gradient={"#58FE69, #00D515"} icon={"fa-solid fa-upload"} />
              <Counter titleText="DOCUMENTS<br>FAILED" count={failedDocuments} color={"#fe036a"} gradient={"#f99dbc, #f5347f"} icon={"fa-solid fa-file-exclamation"} />
            </div> -->

          <div class="grid w-full grid-cols-2 justify-center gap-3 xl:gap-6">
            <Counter titleText="TOTAL DOCUMENTS" count={totalDoc} span="col-span-2" color="#ff6a00" gradient="#f8a500, #ff6a00" icon="fa-file-lines" />
            <Counter titleText="SIGNATURES GENERATED" count={signatureGenerated} span="col-span-2" color="#00B2FF" gradient="#A3E3FF, #00B2FF" icon="fa-gear {activeDoc == 'processing' && signatureGenerated != totalDoc ? 'fa-spin' : ''}" />
            <Counter titleText="DOCUMENTS PUBLISHED" count={publishedDocuments} span="col-span-2" color="#00D515" gradient="#58FE69, #00D515" icon="fa-file-check" />
            <Counter titleText="DOCUMENTS FAILED" count={failedDocuments} span="col-span-2" color="#F03232" gradient="#F87A7A, #F03232" icon="fa-file-exclamation" />
          </div>
          {#if activeItem == "Document Status"}
            <FilePage
              on:release={() => {
                totalDoc--
                if (totalDoc == 0) {
                  notify.info("No Documents Left in the bulk Template as you released all document")
                  push("/publish/bulk")
                  return
                }
                failedDocuments = $bulkJson.filter((a) => a.isDocumentFailed).length
                // failedDocuments--

                if (signatureGenerated != 0) signatureGenerated--
                if (publishedDocuments != 0) publishedDocuments--
              }}
            />
          {:else}
            <DocumentStatusContent
              {startBtnName}
              {activeDoc}
              {showEmailButton}
              width={$widthofProgress}
              on:click={() => {
                showConfirmationModal = true
              }}
              on:retry={() => {
                window.location.reload()
              }}
              on:sendEmail={() => {
                navigateNextPage("send-email")
              }}
              on:viewReport={() => {
                navigateNextPage("view-report")
              }}
            />
          {/if}
        </div>
      {/if}

      {#if activeItem == "Publishing Status" && activeDoc != "completed"}
        <h1 class="select-none pb-6 text-center text-base font-medium text-red-500 mobile:pb-12">Please don't refresh the page while in progress.</h1>
      {/if}
    </div>
  </div>

  <Footer />
</div>
